import React from 'react';
import './TrustAndFAQ.css';

const TRUST_ITEMS = [
  {
    icon: '🔒',
    title: 'Secure Payments',
    desc: 'Processed via Stripe with 256-bit SSL. Your card details never touch our servers.',
  },
  {
    icon: '⚡',
    title: 'Instant Access',
    desc: 'Upgrade and your challenge quota refreshes immediately — no waiting, no manual steps.',
  },
  {
    icon: '🔄',
    title: 'Cancel Anytime',
    desc: 'No contracts, no hidden fees. Upgrade, downgrade, or cancel straight from your dashboard.',
  },
  {
    icon: '🎯',
    title: '30-Day Guarantee',
    desc: "Not happy in the first 30 days? Email us and we'll refund you in full, no questions asked.",
  },
];

const FAQ_ITEMS = [
  {
    q: 'How does the platform actually teach prompt engineering?',
    a: "You learn by doing. Each challenge drops you into a real-world scenario — write the best prompt you can, submit it, and get an AI score with a breakdown across accuracy, efficiency, creativity, and alignment. You see exactly what worked and what didn't.",
  },
  {
    q: "What's the difference between the plans?",
    a: 'Volume and formats. Free gives you 30 challenges and 10 battles a month — enough to get a feel for it. Paid plans unlock higher monthly volumes, unlimited ranked battles, the 10-min Deep Dive format, and the ability to challenge a friend directly.',
  },
  {
    q: 'Can I upgrade or downgrade whenever I want?',
    a: 'Upgrades happen instantly from your dashboard. For downgrades, just reach out to support — we handle it same day with no hassle.',
  },
  {
    q: 'Do I need any background in AI or coding?',
    a: "None at all. Most challenges are pure language — no code required. Coding-specific challenges are clearly labelled. If you can write a sentence, you can start.",
  },
  {
    q: 'How does the ELO and leaderboard work?',
    a: 'Every ranked battle updates your ELO rating — wins push it up, losses bring it down slightly. Your ELO sets your global rank. The leaderboard resets monthly so fresh players always have a shot at the top.',
  },
  {
    q: 'Is my progress and data safe?',
    a: 'All challenge history, scores, and account data are stored encrypted in Firebase. We never sell or share your data with third parties.',
  },
];

const TrustAndFAQ = () => (
  <>
    <div className="challenge-trust-section">
      <div className="challenge-trust-grid">
        {TRUST_ITEMS.map((item) => (
          <div key={item.title} className="challenge-trust-item">
            <div className="challenge-trust-icon">{item.icon}</div>
            <h4>{item.title}</h4>
            <p>{item.desc}</p>
          </div>
        ))}
      </div>
    </div>

    <div className="challenge-faq-section">
      <h3>Frequently Asked Questions</h3>
      <div className="challenge-faq-grid">
        {FAQ_ITEMS.map((item) => (
          <div key={item.q} className="challenge-faq-item">
            <h4>{item.q}</h4>
            <p>{item.a}</p>
          </div>
        ))}
      </div>
    </div>
  </>
);

export default TrustAndFAQ;